import { Controller } from "@hotwired/stimulus"

// Kopiert den Wert des source-Targets in die Zwischenablage und zeigt kurz den Text aus copiedValue auf dem Button.
export default class extends Controller {
  static targets = ["source", "button"]
  static values = { copied: String }

  async copy() {
    await navigator.clipboard.writeText(this.sourceTarget.value)

    const label = this.buttonTarget.textContent
    this.buttonTarget.textContent = this.copiedValue
    setTimeout(() => (this.buttonTarget.textContent = label), 2000)
  }
}
